
import React from 'react';
import { MantineProvider as BaseMantineProvider, createTheme } from '@mantine/core';
import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';

interface MantineProviderProps {
  children: React.ReactNode;
}

export const MantineProvider: React.FC<MantineProviderProps> = ({ children }) => {
  // Create a custom theme with improved defaults for date range picker
  const theme = createTheme({
    // These defaults help ensure Mantine doesn't run into initialization issues
    // with date components
    components: {
      DatePicker: {
        defaultProps: {
          // Ensure valid defaults
          firstDayOfWeek: 0, // Sunday
          allowDeselect: true,
          clearable: true,
          fixOnBlur: true,
          defaultDate: new Date(), // Always provide a default date
          valueFormat: "MMM D, YYYY", // Safe default format
          allowSingleDateInRange: true, // Ensure we can select a single date in range mode
          // Don't set defaultMonth as it's not valid in DatePicker v7
        }
      }
    }
  });

  return (
    <BaseMantineProvider theme={theme} defaultColorScheme="light">
      {children}
    </BaseMantineProvider>
  );
};
